<div class="dropdown" tabindex="0">
  <div class="dropdown-select-toggle" (click)="toggle()" #dropdownToggle>
    <div class="dropdown-select-input">
      @if (getSelectedOptions().length) {
        @for (html of selectedOptionsHtml; track $index) {
          <span [innerHTML]="html" [ngClass]="{'me-1':multiple, 'badge':multiple && showBadge}"></span>
        }
      } @else {
        @if (!hasPlaceholder()) {
          <span>&nbsp;</span>
        } @else {
          <span class="dropdown-select-placeholder">{{ placeholder }}</span>
        }
      }
    </div>
  </div>
  <ul class="dropdown-select show my-1" [ngClass]="{show:isShown()}" #dropdownSelect>
    @if (searchTerm) {
      <div class="input-group form-search-term">
        <input type="text" class="form-control" [ngModel]="searchTerm" [ngModelOptions]="{standalone: true}">
        <button class="btn btn-outline-secondary" type="button" id="button-addon2" (click)="clearSearch()"><i
          class="bi bi-x-lg"></i></button>
      </div>
    }
    @if (selectAll) {
      <div class="text-center my-2 px-3">
        <button (click)="onSelectAll()" class="btn btn-sm btn-primary fw-bold w-100" type="button">SELECT / UNSELECT
          ALL
        </button>
      </div>
    }

    <ng-content></ng-content>

    @if (hasNoOptions()) {
      <div class="px-2 fw-bold">
        No results
      </div>
    }
  </ul>
</div>
